import React, { useState } from "react";
import "../../../Styles/Tpregistration.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiService from "../../../nhrc_apis/ApiService";

const { JobFairAPI } = ApiService;

const Jobfairregisterform = () => {
  const navigate  = useNavigate();
  const { state } = useLocation();
  const eventData = state?.event;

  console.log("EVENT DATA RECEIVED:", eventData);

  const [roles, setRoles] = useState([
    {
      hiring_type:        "",
      job_role:           "",
      experience:         "",
      no_of_openings:     "",
      salary_min:         "",
      salary_max:         "",
      job_location:       "",
      education_required: "",
    },
  ]);

  const [formData, setFormData] = useState({
    company_name:    "",
    company_url:     "",
    full_name:       "",
    nhrc_id:         "",
    email:           "",
    phone:           "",
    receive_updates: false,
  });

  const [errors,       setErrors]       = useState({});
  const [roleErrors,   setRoleErrors]   = useState([{}]);
  const [loading,      setLoading]      = useState(false);

  // ─── VALIDATE SINGLE FORM FIELD ───────────────────────────
  const validateField = (name, value) => {
    let error = "";

    switch (name) {

      case "company_name":
        if (!value || !value.trim()) {
          error = "Company name is required.";
        } else if (value.trim().length < 2) {
          error = "Company name must be at least 2 characters.";
        }
        break;

      case "company_url":
        if (!value || !value.trim()) {
          error = "Company URL is required.";
        } else if (!/^https?:\/\/.+\..+/.test(value.trim())) {
          error = "Enter a valid URL (e.g. https://company.com).";
        }
        break;

      case "full_name":
        if (!value || !value.trim()) {
          error = "Full name is required.";
        } else if (value.trim().length < 3) {
          error = "Full name must be at least 3 characters.";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "Full name must contain only letters and spaces.";
        }
        break;

      case "nhrc_id":
        if (!value || !value.trim()) {
          error = "NHRC ID is required.";
        } else if (value.trim().length < 3) {
          error = "NHRC ID must be at least 3 characters.";
        }
        break;

      case "email":
        if (!value || !value.trim()) {
          error = "Email is required.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) {
          error = "Enter a valid email address (e.g. name@example.com).";
        }
        break;

      case "phone":
        if (!value || !value.trim()) {
          error = "Phone number is required.";
        } else if (!/^[0-9]{10}$/.test(value.trim())) {
          error = "Phone number must be exactly 10 digits.";
        }
        break;

      default:
        break;
    }

    return error;
  };

  // ─── VALIDATE SINGLE ROLE FIELD ───────────────────────────
  const validateRoleField = (name, value) => {
    let error = "";

    switch (name) {

      case "hiring_type":
        if (!value || !value.trim()) {
          error = "Hiring type is required.";
        }
        break;

      case "job_role":
        if (!value || !value.trim()) {
          error = "Job role is required.";
        } else if (value.trim().length < 2) {
          error = "Job role must be at least 2 characters.";
        }
        break;

      case "experience":
        if (!value || !value.trim()) {
          error = "Experience is required.";
        }
        break;

      case "no_of_openings":
        if (!value) {
          error = "Number of openings is required.";
        } else if (isNaN(value) || Number(value) < 1) {
          error = "Number of openings must be at least 1.";
        }
        break;

      case "job_location":
        if (!value || !value.trim()) {
          error = "Job location is required.";
        } else if (value.trim().length < 2) {
          error = "Job location must be at least 2 characters.";
        }
        break;

      case "salary_min":
        if (value && isNaN(value)) {
          error = "Salary min must be a number.";
        }
        break;

      case "salary_max":
        if (value && isNaN(value)) {
          error = "Salary max must be a number.";
        }
        break;

      case "education_required":
        if (!value || !value.trim()) {
          error = "Education required is required.";
        } else if (value.trim().length < 2) {
          error = "Education required must be at least 2 characters.";
        }
        break;

      default:
        break;
    }

    return error;
  };

  // ─── VALIDATE ALL FIELDS ──────────────────────────────────
  const validateAll = () => {
    // Form fields
    const formFields = [
      "company_name", "company_url", "full_name",
      "nhrc_id", "email", "phone",
    ];

    const newErrors = {};
    formFields.forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });
    setErrors(newErrors);

    // Role fields
    const roleFields = [
      "hiring_type", "job_role", "experience",
      "no_of_openings", "job_location",
      "salary_min", "salary_max", "education_required",
    ];

    const newRoleErrors = roles.map((role) => {
      const rErrors = {};
      roleFields.forEach((field) => {
        const error = validateRoleField(field, role[field]);
        if (error) rErrors[field] = error;
      });
      return rErrors;
    });
    setRoleErrors(newRoleErrors);

    const hasFormErrors = Object.keys(newErrors).length > 0;
    const hasRoleErrors = newRoleErrors.some((r) => Object.keys(r).length > 0);

    return !hasFormErrors && !hasRoleErrors;
  };

  // ─── HANDLE FORM CHANGE ───────────────────────────────────
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setFormData((prev) => ({ ...prev, [name]: newValue }));

    if (name !== "receive_updates") {
      const error = validateField(name, newValue);
      setErrors((prev) => ({ ...prev, [name]: error }));
    }
  };

  // ─── HANDLE ROLE CHANGE ───────────────────────────────────
  const handleRoleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedRoles = [...roles];
    updatedRoles[index][name] = value;
    setRoles(updatedRoles);

    // Validate role field on change
    const error = validateRoleField(name, value);
    const updatedRoleErrors = [...roleErrors];
    if (!updatedRoleErrors[index]) updatedRoleErrors[index] = {};
    updatedRoleErrors[index][name] = error;
    setRoleErrors(updatedRoleErrors);
  };

  // ─── ADD ROLE ─────────────────────────────────────────────
  const addRole = () => {
    setRoles([
      ...roles,
      {
        hiring_type:        "",
        job_role:           "",
        experience:         "",
        no_of_openings:     "",
        salary_min:         "",
        salary_max:         "",
        job_location:       "",
        education_required: "",
      },
    ]);
    setRoleErrors([...roleErrors, {}]);
  };

  // ─── HANDLE SUBMIT ────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isValid = validateAll();

    if (!isValid) {
      toast.error("Please fill all required fields correctly.", { autoClose: 2000 });
      return;
    }

    const payload = {
      job_fair_id:     eventData?.id || eventData?.job_fair_id || 0,
      company_name:    formData.company_name.trim(),
      company_url:     formData.company_url.trim(),
      full_name:       formData.full_name.trim(),
      nhrc_id:         formData.nhrc_id.trim(),
      email:           formData.email.trim(),
      phone:           formData.phone.trim(),
      receive_updates: formData.receive_updates,
      roles: roles.map((r) => ({
        hiring_type:        r.hiring_type.trim(),
        job_role:           r.job_role.trim(),
        experience:         r.experience.trim(),
        no_of_openings:     Number(r.no_of_openings),
        salary_min:         r.salary_min.trim(),
        salary_max:         r.salary_max.trim(),
        job_location:       r.job_location.trim(),
        education_required: r.education_required.trim(),
      })),
    };

    console.log("FINAL PAYLOAD SENDING TO API:", payload);

    setLoading(true);
    try {
      const response = await JobFairAPI.registerHrForJobFair(payload);
      console.log("API RESPONSE:", response);
      toast.success("HR Registered Successfully!", { autoClose: 2000 });
      setTimeout(() => {
        navigate("/hrdashboard/Hrjobfairs");
      }, 2000);

    } catch (err) {
      console.error("Registration error:", err);

      const status = err?.response?.status;
      const detail = err?.response?.data?.detail;

      if (status === 422 && Array.isArray(detail)) {
        const firstError = detail[0];
        const field = firstError?.loc?.[1] || "field";
        const msg   = firstError?.msg       || "Validation error";
        toast.error(`Validation error — ${field}: ${msg}`, { autoClose: 3500 });

      } else if (status === 401) {
        toast.error("Session expired. Please login again.", { autoClose: 2500 });
        setTimeout(() => navigate("/login"), 2600);

      } else if (status === 409) {
        toast.error("You have already registered for this job fair!", { autoClose: 2500 });

      } else if (typeof detail === "string") {
        toast.error(detail, { autoClose: 2500 });

      } else {
        toast.error(
          err?.response?.data?.message || "Registration failed. Please try again.",
          { autoClose: 2500 }
        );
      }

    } finally {
      setLoading(false);
    }
  };

  // ─── RENDER ───────────────────────────────────────────────
  return (
    <>
      <div className="jobfairreg-wrapper mt-0">
        <h2 className="jobfairreg-title">REGISTER FORM</h2>

        <form className="jobfairreg-card" onSubmit={handleSubmit} noValidate>
          <div className="jobfairreg-grid">

            {/* Company Name */}
            <div className="jobfairreg-field">
              <label>Company Name*</label>
              <input
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
                placeholder="Enter company name"
                className={errors.company_name ? "input-error" : ""}
              />
              {errors.company_name && <span className="error-text">{errors.company_name}</span>}
            </div>

            {/* Company URL */}
            <div className="jobfairreg-field">
              <label>Company URL*</label>
              <input
                name="company_url"
                value={formData.company_url}
                onChange={handleChange}
                placeholder="https://company.com"
                className={errors.company_url ? "input-error" : ""}
              />
              {errors.company_url && <span className="error-text">{errors.company_url}</span>}
            </div>

            {/* Full Name */}
            <div className="jobfairreg-field">
              <label>Full Name*</label>
              <input
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                placeholder="Enter your full name"
                className={errors.full_name ? "input-error" : ""}
              />
              {errors.full_name && <span className="error-text">{errors.full_name}</span>}
            </div>

            {/* NHRC ID */}
            <div className="jobfairreg-field">
              <label>NHRC ID*</label>
              <input
                name="nhrc_id"
                value={formData.nhrc_id}
                onChange={handleChange}
                placeholder="Enter your NHRC ID"
                className={errors.nhrc_id ? "input-error" : ""}
              />
              {errors.nhrc_id && <span className="error-text">{errors.nhrc_id}</span>}
            </div>

            {/* Email */}
            <div className="jobfairreg-field">
              <label>Email Id*</label>
              <input
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className={errors.email ? "input-error" : ""}
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>

            {/* Phone */}
            <div className="jobfairreg-field">
              <label>Phone Number*</label>
              <input
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter 10-digit phone number"
                maxLength={10}
                className={errors.phone ? "input-error" : ""}
              />
              {errors.phone && <span className="error-text">{errors.phone}</span>}
            </div>

            {/* Company Requirements Header */}
            <div className="jobfairreg-company-header">
              <span>Company Requirements</span>
              <button
                type="button"
                className="jobfairreg-add-role-btn"
                onClick={addRole}
              >
                ADD ROLE +
              </button>
            </div>

            {/* Roles */}
            {roles.map((role, index) => (
              <div
                key={index}
                id={`jobfair-role-block-${index}`}
                className="jobfair-role-block"
              >
                <div className="jobfair-role-header">
                  <span>Role {index + 1}</span>
                </div>

                {/* Hiring Type */}
                <div className="jobfairreg-hiring-type">
                  <label>Hiring Type*</label>
                  <div className="jobfairreg-radio-group">
                    {["Internship", "Training", "Full Time"].map((type) => (
                      <label key={type}>
                        <input
                          type="radio"
                          name="hiring_type"
                          value={type}
                          checked={role.hiring_type === type}
                          onChange={(e) => handleRoleChange(index, e)}
                        />
                        {type}
                      </label>
                    ))}
                  </div>
                  {roleErrors[index]?.hiring_type && (
                    <span className="error-text">{roleErrors[index].hiring_type}</span>
                  )}
                </div>

                {/* Job Role */}
                <div className="jobfair-role-field">
                  <label>Job Role*</label>
                  <input
                    name="job_role"
                    value={role.job_role}
                    onChange={(e) => handleRoleChange(index, e)}
                    placeholder="Enter job role"
                    className={roleErrors[index]?.job_role ? "input-error" : ""}
                  />
                  {roleErrors[index]?.job_role && (
                    <span className="error-text">{roleErrors[index].job_role}</span>
                  )}
                </div>

                {/* Experience */}
                <div className="jobfair-role-field">
                  <label>Experience*</label>
                  <input
                    name="experience"
                    value={role.experience}
                    onChange={(e) => handleRoleChange(index, e)}
                    placeholder="e.g. 0-2 years"
                    className={roleErrors[index]?.experience ? "input-error" : ""}
                  />
                  {roleErrors[index]?.experience && (
                    <span className="error-text">{roleErrors[index].experience}</span>
                  )}
                </div>

                {/* No. of Openings */}
                <div className="jobfair-role-field">
                  <label>No. of Openings*</label>
                  <input
                    name="no_of_openings"
                    type="number"
                    value={role.no_of_openings}
                    onChange={(e) => handleRoleChange(index, e)}
                    placeholder="e.g. 5"
                    min={1}
                    className={roleErrors[index]?.no_of_openings ? "input-error" : ""}
                  />
                  {roleErrors[index]?.no_of_openings && (
                    <span className="error-text">{roleErrors[index].no_of_openings}</span>
                  )}
                </div>

                {/* Job Location */}
                <div className="jobfair-role-field">
                  <label>Job Location*</label>
                  <input
                    name="job_location"
                    value={role.job_location}
                    onChange={(e) => handleRoleChange(index, e)}
                    placeholder="Enter job location"
                    className={roleErrors[index]?.job_location ? "input-error" : ""}
                  />
                  {roleErrors[index]?.job_location && (
                    <span className="error-text">{roleErrors[index].job_location}</span>
                  )}
                </div>

                {/* Salary */}
                <div className="jobfair-role-salary-group">
                  <div>
                    <label>Salary in LPA (Min)</label>
                    <input
                      name="salary_min"
                      value={role.salary_min}
                      onChange={(e) => handleRoleChange(index, e)}
                      placeholder="e.g. 3"
                      className={roleErrors[index]?.salary_min ? "input-error" : ""}
                    />
                    {roleErrors[index]?.salary_min && (
                      <span className="error-text">{roleErrors[index].salary_min}</span>
                    )}
                  </div>
                  <div>
                    <label>Salary in LPA (Max)</label>
                    <input
                      name="salary_max"
                      value={role.salary_max}
                      onChange={(e) => handleRoleChange(index, e)}
                      placeholder="e.g. 8"
                      className={roleErrors[index]?.salary_max ? "input-error" : ""}
                    />
                    {roleErrors[index]?.salary_max && (
                      <span className="error-text">{roleErrors[index].salary_max}</span>
                    )}
                  </div>
                </div>

                {/* Education Required */}
                <div className="jobfair-role-field">
                  <label>Education Required*</label>
                  <input
                    name="education_required"
                    value={role.education_required}
                    onChange={(e) => handleRoleChange(index, e)}
                    placeholder="e.g. B.Tech, MBA"
                    className={roleErrors[index]?.education_required ? "input-error" : ""}
                  />
                  {roleErrors[index]?.education_required && (
                    <span className="error-text">{roleErrors[index].education_required}</span>
                  )}
                </div>

              </div>
            ))}

          </div>

          {/* Checkbox */}
          <div className="jobfairreg-checkbox" style={{ margin: "16px 0" }}>
            <p>Would you like to receive updates about future events and professional opportunities?</p>
            <input
              type="checkbox"
              name="receive_updates"
              checked={formData.receive_updates}
              onChange={handleChange}
            />
          </div>

          <button
            type="submit"
            className="jobfairreg-submit"
            disabled={loading}
          >
            {loading ? "Submitting..." : "SUBMIT"}
          </button>

        </form>
      </div>

      <ToastContainer position="top-center" />
    </>
  );
};

export default Jobfairregisterform;